import React from 'react';
import styled from 'styled-components';

import Icon from 'components/Icon';

const EmployeesCountBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #45494D;
  border-radius: 4.5vw;
  width: 12vw;
  padding: 0.8vw 0;
  text-align: center;
`;

const EmployeesCountValue = styled.span`
  color: #fff;
  font-weight: 700;
  font-size: 4.2vw;
  line-height: 100%;
  margin-right: 1vw;
`;

const EmployeesCountBadge = ({ value }) => {
  return (
    <EmployeesCountBadgeWrapper>
      <EmployeesCountValue>
        {value}
      </EmployeesCountValue>
      <Icon
        name={'users'}
        size={'3.4vw'}
        color={'#fff'}
        strokeWidth={2.5}
        style={{
          verticalAlign: 'top'
        }}
      />
    </EmployeesCountBadgeWrapper>
  );
};

export default EmployeesCountBadge;